export default __webpack_public_path__ + "static/media/sponsor_canada_secondary.ea8877f4.png";